import React from "react";
import cvData from "../data/cvData.json";
import { convertTextToLinks } from "../helpers/helper";

const getOrdinalSuffix = (day) => {
  if (day > 3 && day < 21) return "th";
  switch (day % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  if (typeof dateStr === "string" && dateStr.toLowerCase() === "present") {
    return "present";
  }

  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) {
    return dateStr;
  }

  const day = date.getDate();
  const month = new Intl.DateTimeFormat("en-ZA", { month: "long" }).format(date);
  const year = date.getFullYear();

  return `${day}${getOrdinalSuffix(day)} of ${month}, ${year}`;
};

const calculateDuration = (startDateStr, endDateStr) => {
  const startDate = new Date(startDateStr);
  const endDate =
    typeof endDateStr === "string" && endDateStr.toLowerCase() === "present"
      ? new Date()
      : new Date(endDateStr);

  const diffTime = Math.abs(endDate - startDate);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  const months = Math.floor(diffDays / 30);
  const years = Math.floor(months / 12);

  return years
    ? `${years} ${years === 1 ? "year" : "years"} ${months % 12} ${
        months % 12 === 1 ? "month" : "months"
      }`
    : `${months} ${months === 1 ? "month" : "months"}`;
};

const Experience = () => {
  const { experience } = cvData;

  return (
    <section id="experience" className="relative z-10 mx-auto w-full max-w-6xl px-6 py-12">
      <h2 className="section-title">Professional Experience</h2>
      <p className="mt-4 text-sm text-text-secondary">
        8+ years of progressive experience building scalable web applications
      </p>
      <div className="relative mt-8 space-y-6 pl-8">
        <div className="absolute left-3 top-0 h-full w-px bg-white/10" />
        {experience.map((exp, index) => (
          <div key={index} className="relative glass-card p-6 md:p-8" itemProp="hasOccupation" itemScope itemType="https://schema.org/Role">
            <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
              <div>
                <h3 className="text-2xl font-semibold text-white" itemProp="jobTitle">{exp.title}</h3>
                <p className="text-base font-medium text-text-secondary" itemProp="worksFor">
                  {exp.company}
                </p>
              </div>
              <div className="text-sm text-text-secondary md:text-right">
                <p><meta itemProp="startDate" content={exp.startDate} />{`${formatDate(exp.startDate)} - `}<meta itemProp="endDate" content={exp.endDate} />{formatDate(exp.endDate)}</p>
                <p className="font-semibold text-text-color">
                  {calculateDuration(exp.startDate, exp.endDate)}
                </p>
              </div>
            </div>
            <div className="mt-5 space-y-2 text-sm text-text-secondary md:text-base">
              {exp.responsibilities.map((res, i) => (
                <p key={i} className="flex gap-2">
                  <span className="text-accent">•</span>
                  <span>{convertTextToLinks(res)}</span>
                </p>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Experience;
